// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1fOM8","label":"CategoryService_label__9JpC_","location":"CategoryService_location__1SEX_"};